import React from 'react';
import _ from 'lodash';

import trainTime from '../../lib/TrainTime';
import { translate as t } from '../../lib/I18n';
import ValidatedFormField from '../form/ValidatedField';


function CardExpiryYear (props) {
    const currentYear = trainTime().year();
    const yearsRange = _.range(currentYear, currentYear + 11);

    return (
        <div className="card-expiry-year">
            <ValidatedFormField { ...props }
                type="select"
                id="expiryYear"
                name="year"
                field="expiryYear"
                groupClassName="select-container select-container--no-margin"
                label={ t('customerdetails.payment.expiryyear') }
                placeholder={ t('customerdetails.payment.expiryyear') }
                labelClassName="sr-only"
                autoComplete="cc-exp-year">
                    <option>{ t('customerdetails.payment.expiryyear.defaultOption') }</option>
                    { yearsRange.map((year) => (
                        <option key={ year } value={ year }>{ year }</option>
                    )) }
            </ValidatedFormField>
        </div>
    );
}

CardExpiryYear.propTypes = _.pick(ValidatedFormField.propTypes, [
    'form',
    'onChange',
    'required',
    'disabled',
    'visited',
    'validation'
]);


export default CardExpiryYear;



// WEBPACK FOOTER //
// ./src/components/payment/CardExpiryYear.js